// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2mac1","header":"ReportDetails_header__ZFfU3","title":"ReportDetails_title__2JgAx","left":"ReportDetails_left__3_zNR"};